import { RefObject, useLayoutEffect, useRef, useState } from 'react'

/**
 * Largura de um elemento, acompanhando o redimensionamento. Medir o próprio elemento (e não a janela) é o que
 * funciona aqui: o menu lateral do painel come 280 px, então a janela mente sobre o espaço que a tela tem.
 * Devolve 0 até a primeira medida (que sai antes da pintura, por causa do useLayoutEffect).
 */
export function useElementWidth<T extends HTMLElement>(): [RefObject<T | null>, number] {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(0)
  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return undefined
    setWidth(el.getBoundingClientRect().width)
    if (typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver(() => setWidth(el.getBoundingClientRect().width))
    ro.observe(el)
    return () => ro.disconnect()
  }, [])
  return [ref, width]
}
